import { Image } from 'react-native';

import Images from '../../Images';

const images = {
  ...Images,

  ic_info_circle: Image.resolveAssetSource(
    require('./../../../Assets/Images/Icons/icInfoCircle.png'),
  ),
  ic_sync: Image.resolveAssetSource(require('./../../../Assets/Images/Icons/icSync.png')),
  ic_close_white: Image.resolveAssetSource(
    require('./../../../Assets/Images/Icons/icCloseWhite.png'),
  ),
};

export default images;
